<template>
  <div class="import-config-form">
    <el-dialog :title="dialogTitle" :visible.sync="dialogConfigVisible" :before-close="close" v-loading="loading" :close-on-click-modal="false">
        <pt-form-item label="实验室检测平台" :labelWidth="labelWidth" :required="true">
          <sequencing-technology-type-selector v-model="configForm.sequencingTechnologyType" v-validate="'required'" data-vv-as="实验室检测平台" name="sequencingTechnologyType"></sequencing-technology-type-selector>
        </pt-form-item>
        <pt-form-item label="计算类型" :labelWidth="labelWidth" :required="true">
          <model-type-selector v-model="configForm.modelType" v-validate="'required'" data-vv-as="计算类型" name="modelType"></model-type-selector>
        </pt-form-item>
        <pt-form-item label="性别类型" :labelWidth="labelWidth" :required="true">
          <detection-config-gender-seletor v-model="configForm.detectionItemGender" v-validate="'required'" data-vv-as="性别类型" name="detectionItemGender"></detection-config-gender-seletor>
        </pt-form-item>
        <pt-form-item label="导入模式" :labelWidth="labelWidth" :required="true">
          <el-radio-group v-model="configForm.dryrun" v-validate="'required'" data-vv-as="导入模式" name="dryrun">
            <el-radio :disabled="disabled" class="radio" :label='true'>模拟导入验证</el-radio>
            <el-radio :disabled="disabled" class="radio" :label='false'>正式导入配置</el-radio>
          </el-radio-group>
        </pt-form-item>
        <pt-form-item label="配置库名称" :labelWidth="labelWidth" :required="true">
          <config-suite-name-selector v-model="configForm.configSuiteName" v-validate="'required'" data-vv-as="配置库名称" name="configSuiteName"></config-suite-name-selector>
            <!-- <el-input v-model="configForm.configSuiteName" class="config-name"></el-input> -->
        </pt-form-item>
        <pt-form-item label="配置文件" :labelWidth="labelWidth" :required="true">
          <el-upload
            ref="configFile0"
            class="upload-demo"
            action="aa"
            :auto-upload="false"
            :multiple="false"
            :file-list="configFile"
            :on-change="handleChange"
            :on-remove="removeHandler">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </pt-form-item>
      <div class="message">
        <hr v-if="Object.keys(this.message).length">
        <p class="item">
          <span v-if="this.message.detectionItemsFound">已找到的检测项数量:{{message.detectionItemsFound}}</span>
          <span v-if="this.message.skippedItemsCount">跳过的检测项数量:{{message.skippedItemsCount}}</span>
          <span v-if="this.message.objectsSaved">最终保存的对象数量:{{message.objectsSaved}}</span>
          <span v-if="this.message.objectRemoved">最终删除的对象数量:{{message.objectRemoved}}</span>
        </p>
        <p class="item" v-if="message.detectionItemIdsNotFound"><span>在当前数据库中未匹配到的检测项Id：</span>{{message.detectionItemIdsNotFound.toString()}}</p>
        <p class="item" v-if="message.detectionNamesNotFound"><span>在当前数据库中未匹配到的检测项Id：</span>{{message.detectionNamesNotFound.toString()}}</p>
        <p class="item" v-if="message.detectionNamesToCreate"><span>在当前数据库中未匹配到，将创建的检测项：</span>{{message.detectionNamesToCreate.toString()}}</p>
        <div class="flex">
          <div v-if="this.message.errors">
            <h4>错误信息:</h4>
            <div v-for="(item,index) in this.message.errors" :key="index">
              <p>{{item}}</p>
            </div>
          </div>
          <div v-if="this.message.warnings">
            <h4>警告信息:</h4>
            <div v-for="(item,index) in this.message.warnings" :key="index">
              <p>{{item}}</p>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="certain">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import modelTypeSelector from './componentsWithData/model-type-selector'
import detectionConfigGenderSeletor from '../detection-config-gender-selector'
import sequencingTechnologyTypeSelector from './componentsWithData/sequencing-technology-type-selector'
import configSuiteNameSelector from './componentsWithData/config-suite-name-selector'
const canNotSelectNames = ['ASA成人基因检测', 'ASA儿童基因检测']
export default {
  props: {
    dialogConfigVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    detectionCategory: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      labelWidth: '25%',
      configForm: {
        detectionItemCategory: this.detectionCategory,
        dryrun: true,
        detectionItemId: this.$route.params.id,
        sequencingTechnologyType: '',
        agentId: ''
        // configFile:{},
      },
      loading: false,
      successNum: [],
      uploadForm: new FormData(),
      message: {},
      disabled: true,
      configFile: []
    }
  },
  components: {
    modelTypeSelector,
    detectionConfigGenderSeletor,
    sequencingTechnologyTypeSelector,
    configSuiteNameSelector
  },
  computed: {
    params () {
      return this.configForm
    }
  },
  watch: {
    configForm: {
      handler: function (val, old) {
        // console.log(val)
        let formatSrc = val.configSuiteName && val.configSuiteName.replace(/\s+/g, '')
        if (val.configSuiteName && canNotSelectNames.includes(formatSrc)) {
          this.$message.error('不能填写系统内配置库名称！')
        }
        this.$emit('input', val)
      },
      deep: true
    },
    configFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.configFile = val.slice(-1)
        }
      },
      deep: true
    },
    dialogConfigVisible (val) {
      if (val) {
        this.reset()
      }
    }
  },
  methods: {
    successHandler (response, file, fileList) {
      this.loading = false
      console.log('response---------', response)
    },
    removeHandler (file, fileList) {
      this.configFile = fileList
    },
    close () {
      this.$emit('update', false)
    },
    formValidate () {
      return validate(this, this.configForm)
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.configFile = fileList
    },
    reset () {
      this.disabled = true
      this.message = {}
      this.configFile = []
      this.configForm = {
        detectionItemCategory: this.detectionCategory,
        dryrun: true,
        detectionItemId: this.$route.params.id,
        sequencingTechnologyType: '',
        agentId: ''
      }
    },
    certain () {
      if (!this.configFile.length) {
        this.$message.error('请上传配置文件')
        return
      }
      let formatSrc = this.configForm.configSuiteName && this.configForm.configSuiteName.replace(/\s+/g, '')
      if (this.configForm.configSuiteName && canNotSelectNames.includes(formatSrc)) {
        this.$message.error('不能填写系统内配置库名称！')
        return
      }
      this.formValidate().then(async () => {
        this.loading = true
        this.uploadForm = new FormData()
        try {
          let primary = await this.$store.dispatch('getPrimaryOrganization')
          this.uploadForm.append('configFile', this.configFile[0].raw)
          this.uploadForm.append('detectionItemCategory', this.configForm.detectionItemCategory)
          this.uploadForm.append('modelType', this.configForm.modelType)
          this.uploadForm.append('detectionItemGender', this.configForm.detectionItemGender)
          this.uploadForm.append('dryrun', this.configForm.dryrun)
          this.uploadForm.append('detectionItemId', this.configForm.detectionItemId)
          this.uploadForm.append('sequencingTechnologyType', this.configForm.sequencingTechnologyType)
          this.uploadForm.append('agentId', primary.tenantId)
          this.uploadForm.append('configSuiteName', this.configForm.configSuiteName)
          // 新增的配置默认都为非引擎配置
          this.uploadForm.append('engineDefault', false)

          this.$store.dispatch('importConfigParams', this.uploadForm).then(res => {
            console.log('res', res)
            // this.configFile[0].status = 'ready'
            if (res.status === 400) {
              this.loading = false
              this.$message.error('操作失败！')
              this.$message.error(res.error)
            } else if (res.status === 200) {
              this.loading = false
              this.message = res.data
              if (this.message.objectsSaved === 0) {
                this.$message.warning('导入失败')
              } else {
                this.$message.success('操作成功！')
                // 非模拟导入
                if (!this.configForm.dryrun) {
                  // 刷新配置列表页面,重置上传表单
                  this.reset()
                  this.close()
                  this.$emit('updateConfig')
                } else {
                  this.disabled = false
                }
              }
            }
          }).catch((error) => {
            console.log(error)
            this.loading = false
            // this.close()
            this.$message.error(error || '操作失败')
          })
        } catch (err) {
          this.loading = false
          console.log(err)
          this.$message.error(err)
        }
      })
    }
  }
}
</script>

<style lang="less">
.import-config-form{
  .el-dialog{
    min-width:600px;
  }
  .el-dialog__body{
    display: flex;
    flex-direction: column;
  }
  .el-select,.config-name{
    width:80%;
  }
	.message{
		div.flex{
			display: flex;
			>div{
				margin-right: 2rem;
				p{
					padding-left: 2em;
				}

			}
		}
		p{
      line-height: 20px;
      margin:5px 0;
		}
		.item{
			&:first-child{
				span{
					margin-right:2rem;
				}
			}
			span{
        font-weight: bold;
        display: inline-block;
        margin-right:20px;
			}
		}
	}
}

</style>
